import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  CircularProgress,
  Tooltip,
  Grid,
} from '@mui/material';
import { DropzoneUpload } from 'routes/Pages/Dockets/components/InputRenderer';

const ChipperDocsDialog = ({
  open,
  onClose,
  files = [],
  isLoading,
  handleFileChange,
  handleDeleteFiles,
  viewFile,
  docType = 'chipperDocs',
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography fontSize="1.5rem">Chipper Documents</Typography>
      </DialogTitle>

      <DialogContent>
        <Grid item xs={12} md={6}>
          <DropzoneUpload label="" onFileSelect={handleFileChange('files')} multiple />

          <Box
            sx={{
              display: 'flex',
              overflowX: 'auto',
              gap: 1,
              py: 1,
              minHeight: 60,
            }}>
            {isLoading ? (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <CircularProgress size={20} />
                <Typography sx={{ ml: 1 }}>Loading Docs...</Typography>
              </Box>
            ) : files.length > 0 ? (
              files.map(
                (file, idx) =>
                  file.docType === docType && (
                    <Tooltip title={file.documentName} key={idx}>
                      <Chip
                        label={file.documentName.length > 20 ? file.documentName.slice(0, 18) + '...' : file.documentName}
                        color="success"
                        onDelete={() => handleDeleteFiles(file)}
                        onClick={() => viewFile(file)}
                        sx={{ fontSize: 11, height: 24 }}
                      />
                    </Tooltip>
                  ),
              )
            ) : (
              <Typography>No documents uploaded</Typography>
            )}
          </Box>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChipperDocsDialog;
